import React from "react";
import { Table, Skeleton } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IRequest } from "../models";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { Routes } from "../../../../../AppRoutes";
import { useHistory } from "react-router-dom";
import { useGetMyRequests } from "../hooks";
import { exportWarehouseDocx } from "../export/template";
import * as docx from "docx";
import { saveAs } from "file-saver";

const columns: ColumnsType<IRequest> = [
  {
    title: "Mã yêu cầu",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdDateTime",
    key: "createdDateTime",
    render(value, record, index) {
      return getDDMMYYYFormat(record?.createdDateTime);
    },
  },
  {
    title: "Người tạo",
    dataIndex: "createdBy",
    key: "createdBy",
    render(value, record, index) {
      return record?.createdBy?.user?.displayName;
    },
  },
  {
    title: "Yêu cầu",
    dataIndex: "type",
    key: "type",
    render(value, record, index) {
      return <span className="flag warning">Xuất kho</span>;
    },
  },
  {
    title: "Đề nghị xuất kho",
    dataIndex: "eMaterialTypeExport",
    key: "eMaterialTypeExport",
    render(value, record, index) {
      return record?.fields?.eTypeExportWarehouse;
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "eRequestStatus",
    key: "eRequestStatus",
    render(value, record, index) {
      return <ApprovalStatus status={record?.fields?.eRequestStatus} />;
    },
  },
  {
    title: "",
    dataIndex: "Download",
    key: "Download",
    render(value, record, index) {
      return (
        <Button
        onClick={(e) => {
          e.stopPropagation();
          
          const doc6 = exportWarehouseDocx(record);

            docx.Packer.toBlob(doc6).then((blob) => {
              saveAs(
                blob,
                `Đề nghị xuất kho - ${getDDMMYYYFormat(new Date())}.docx`
              );
            });
        }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      );
    },
  },
];

export const MyRequests: React.FC = () => {
  const history = useHistory();

  const { data, isLoading } = useGetMyRequests();

  return (
    <>
      {!isLoading && (
        <Table
          columns={columns}
          dataSource={data}
          rowClassName="cursor-pointer"
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                history.push(
                  Routes.exportWarehouseDetail.path.replace(":id", record.id)
                );
              },
            };
          }}
        />
      )}
      {isLoading && <Skeleton />}
    </>
  );
};
